import CommunityThreadListingPage from "@/containers/CommunityThreadListingPage";

import { renderMetaData } from "@/utils";

const CommunityThreadListing = () => {
  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/community/thread/",
    title: "Shyft Community Posts Sitemap",
    description:
      "Explore the latest Shyft community posts on Shyft Community sitemap. Stay updated with the latest discussions, tips, and tricks on various topics related to our Shyft community.",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <CommunityThreadListingPage />
    </>
  );
};

export default CommunityThreadListing;
